import { render, staticRenderFns } from "./rfq-add.vue?vue&type=template&id=24e498b2&scoped=true"
import script from "./rfq-add.vue?vue&type=script&lang=js"
export * from "./rfq-add.vue?vue&type=script&lang=js"
import style0 from "./rfq-add.vue?vue&type=style&index=0&id=24e498b2&prod&scoped=true&lang=css"
import style1 from "./rfq-add.vue?vue&type=style&index=1&id=24e498b2&prod&lang=css"
import style2 from "./rfq-add.vue?vue&type=style&index=2&id=24e498b2&prod&scoped=true&lang=css"
import style3 from "./rfq-add.vue?vue&type=style&index=3&id=24e498b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e498b2",
  null
  
)

export default component.exports